export const GRAPHS_TABS = ["Graphs", "Graph"];
